import React from 'react';

import { classNames } from '@/helpers/classNames';

import styles from '../Onboarding.module.scss';

const InnerStepFour: React.FC = () => {
	return (
		<>
			<div className={styles['heading']}>
				<img
					className={styles['svg']}
					src="/assets/onboarding-icons/bar-line-chart.svg"
				/>
				Get better insight
			</div>
			<div className={classNames([styles['text'], 'mt-sm'])}>
				Gather feedback with automatic team surveys. Get instant
				insights and detailed reports.
			</div>
		</>
	);
};

export default InnerStepFour;
